import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { EventsService } from '../events-service/events.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../events-service/events.service";
var AuthorizeNetService = /** @class */ (function () {
    function AuthorizeNetService(http, eventService) {
        this.http = http;
        this.eventService = eventService;
    }
    AuthorizeNetService.prototype.getAuthnetNonce = function (cardData) {
        cardData.cardNumber = cardData.cardNumber.replace(/-/g, '');
        var authData = this.getAuthData();
        var secureData = { authData: authData, cardData: cardData };
        return Observable.create(function (observer) {
            Accept.dispatchData(secureData, function (response) {
                if (response.messages.resultCode === 'Error') {
                    observer.error(response.messages.message);
                }
                else {
                    observer.next(response.opaqueData);
                }
                observer.complete();
            });
        });
    };
    AuthorizeNetService.prototype.executePayment = function (eventId, entity, entityId, nonce) {
        return this.http.post("/api/v1/events/" + eventId + "/" + entity + "/" + entityId + "/authnet-execute", {
            opaqueData: nonce
        });
    };
    AuthorizeNetService.prototype.getAuthData = function () {
        return {
            clientKey: this.eventService.eventData.processors.authorize_net.client_key,
            apiLoginID: this.eventService.eventData.processors.authorize_net.login_id,
        };
    };
    AuthorizeNetService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AuthorizeNetService_Factory() { return new AuthorizeNetService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.EventsService)); }, token: AuthorizeNetService, providedIn: "root" });
    return AuthorizeNetService;
}());
export { AuthorizeNetService };
